import token from 'entities/token';

export const permissions = {
  deployment: {
    createAir: 'DPL_C_AIR',
    updateAir: 'DPL_U_AIR',
    createHospital: 'DPL_C_HOSPITAL',
    deleteHospital: 'DPL_D_HOSPITAL',
    updateHospital: 'DPL_U_HOSPITAL',
    readHospital: 'DPL_R_HOSPITAL',
    createAirDevice: 'DPL_C_AIR_DEVICE',
    deleteAirDevice: 'DPL_D_AIR_DEVICE',
    createInfusion: 'DPL_C_INFUSION',
    updateInfusion: 'DPL_U_INFUSION',
    createInfusionDevice: 'DPL_C_INFU_DEVICE',
    deleteInfusionDevice: 'DPL_D_INFU_DEVICE',
    readScreen: 'DPL_R_DEPLOY_SCR',
    updatePEP: 'DPL_U_PEP',
    readReports: 'DPL_R_REPORTS',
    readVPN: 'DPL_R_VPN',
    createVPN: 'DPL_C_VPN',
    updateVPN: 'DPL_U_VPN',
    deleteVPN: 'DPL_D_VPN',
    createHospitalGroup: 'DPL_C_HOSPITAL_GROUP',
    readHospitalGroup: 'DPL_R_HOSPITAL_GROUP',
    updateHospitalGroup: 'DPL_U_HOSPITAL_GROUP',
    deleteHospitalGroup: 'DPL_D_HOSPITAL_GROUP',
    createMonitor: 'DPL_C_MON',
    updateMonitor: 'DPL_U_MON',
    createMonitorDevice: 'DPL_C_MON_DEVICE',
    deleteMonitorDevice: 'DPL_D_MON_DEVICE',
  },
  header: {
    readChangeLang: 'HDR_R_CHANGE_LANG',
    readConnectivity: 'HDR_R_CONNECTIVITY_OF',
    readConfig: 'HDR_R_CFG',
    readChangeDisplay: 'HDR_R_CHANGE_DISPLAY',
    readProfile: 'HDR_R_PROFILE',
    read: 'HDR_R',
  },
  login: {
    readLogon: 'LGN_R_LOGON',
    updateResetPassword: 'LGN_U_RESET_PASSWD',
    updateChangeLang: 'LGN_U_CHANGE_LANG',
    updateChangePassword: 'LGN_U_CHANGE_PASSWD',
    readResetScreen: 'LGN_R_RESET_SCR',
    readLogoff: 'LGN_R_LOGOFF',
  },
  bed: {
    readBedScreen: 'BED_R_BED_SCR',
    readCards: 'BED_R_CARDS',
    updateDragCards: 'BED_U_DRAG_CARDS',
    readICUS: 'BED_R_ICUS',
    readSelectICU: 'BED_R_SELECT_ICU',
    readHospitals: 'BED_R_HOSPITALS',
    readSelectHospital: 'BED_R_SELECT_HOSPITAL',
    toggleTemperature: 'BED_U_TOGGLE_TEMPERATURE',
    toggleCarbonDioxide: 'BED_U_TOGGLE_CARBON_DIOXIDE',
  },
  user: {
    createUserMultiHospital: 'USR_C_MH',
    readUsersMultiHospital: 'USR_R_USRS_MH',
    updateSingleProfile: 'USR_U_SINGLE_PROFILE',
    updateBatchProfile: 'USR_U_BATCH_PROFILE',
    createUserOwnHospital: 'USR_C_USR_OH',
    readUsersOwnHospital: 'USR_R_USRS_OH',
    updateUsersOwnHospital: 'USR_U_USRS_OH',
    updateActiveUser: 'USR_U_ACTIVATE_USR',
    readLogUser: 'USR_R_LOG_USR',
    createBatchUsers: 'USR_C_BATCH_USRS',
    deleteUsersMultiHospital: 'USR_D_USRS_MH',
    deleteUsersOwnHospital: 'USR_D_USRS_OH',
    readExportUsers: 'USR_R_EXPORT_USRS',
    readUsersScreen: 'USR_R_USRS_SCR',
    crudLogs: 'USR_CRUD_LOGS',
    readSingleHospital: 'SINGLE_HOSPITAL',
    readUnlimitedSessionTimeout: 'UNLIMITED_SESSION_TIMEOUT',
  },
  assistManagement: {
    readConfigAlarmsMultiHospital: 'AMNG_R_CFG_ALARM_MH',
    createTempPresetMultiHospital: 'AMNG_C_TEMP_PRESET_MH',
    readFreqSendPEPMultiHospital: 'AMNG_R_FREQ_SEND_PEP_MH',
    updateFreqSendPEPMultiHospital: 'AMNG_U_FREQ_SEND_PEP_MH',
    readConfigAlarm: 'AMNG_R_CFG_ALARM',
    createTempPresetOwnHospital: 'AMNG_C_TEMP_PRESET_OH',
    readFreqSendPEP: 'AMNG_R_FREQ_SEND_PEP',
    updateFreqSendPEP: 'AMNG_U_FREQ_SEND_PEP',
    readPresetMultiHospital: 'AMNG_R_PRESET_MH',
    createPresetMultiHospital: 'AMNG_C_PRESET_MH',
    updatePresetMultiHospital: 'AMNG_U_PRESET_MH',
    deletePresetMultiHospital: 'AMNG_D_PRESET_MH',
    readPresetAllocMultiHospital: 'AMNG_R_PRESET_ALLOC_MH',
    updatePresetAllocMultiHospital: 'AMNG_U_PRESET_ALLOC_MH',
    updatePresetPubMultiHospital: 'AMNG_U_PRESET_PUB_MH',
    readPresetOwnHospital: 'AMNG_R_PRESET_OH',
    createPresetOwnHospital: 'AMNG_C_PRESET_OH',
    updatePresetOwnHospital: 'AMNG_U_PRESET_OH',
    deletePresetOwnHospital: 'AMNG_D_PRESET_OH',
    readPresetAllocOwnHospital: 'AMNG_R_PRESET_ALLOC_OH',
    updatePresetAllocOwnHospital: 'AMNG_U_PRESET_ALLOC_OH',
    updatePresetPubOwnHospital: 'AMNG_U_PRESET_PUB_OH',
  },
  configurations: {
    readManageProfile: 'CFG_R_MNG_PROFILE',
    readManageAccessControlProd: 'CFG_R_MNG_ACCESS_CTRL_PROD',
    readManageLang: 'CFG_R_MNG_LANG',
    readManageEmailTPL: 'CFG_R_MNG_EMAIL_TPL',
    readManageMedications: 'CFG_R_MNG_MEDICATIONS',
    readReportICUBed: 'CFG_R_REPORT_ICU_BED',
    readCreatePresetsDefault: 'CFG_RC_PRESETS_DEFAULT',
    readManageSystemLogs: 'CFG_R_MNG_SYSTEM_LOGS',
    createEmail: 'CFG_C_EMAIL',
    createAlarm: 'CFG_C_ALARM',
    createProfile: 'CFG_C_PRFL',
  },
  monitor: {
    readDashboard: 'MON_R_DASHBOARD',
    readCards: 'MON_R_CARDS',
    updateDragCards: 'MON_U_DRAG_CARDS',
    readHistory: 'MON_R_HISTORY',
    readGraph: 'MON_R_GRAPH',
    updateSelectDate: 'MON_U_SELECT_DATE',
    updateSelectView: 'MON_U_SELECT_VIEW',
    updateSelectVitalSigns: 'MON_U_SELECT_VITAL_SIGNS',
    updateRule: 'MON_U_RULE',
    readAlarmDefaultParams: 'MON_R_ALARM_DEFAULT_PARAMS',
    readSelectedTempPreset: 'MON_R_SELECTED_TEMP_PRESET',
    readUpdateSelectPreset: 'MON_RU_SELECT_PRESET',
    readSelectPEPPage: 'MON_R_SELECT_PEP_PAGE',
    readSelectPEPItemsPerPage: 'MON_R_SELECT_PEP_ITEMS_PER_PAGE',
    readSelectPEPItemsToSend: 'MON_R_SELECT_PEP_ITEMS_TO_SEND',
    updateEditPEPItemsToSend: 'MON_U_EDIT_PEP_ITEMS_TO_SEND',
    createSendPEPItems: 'MON_C_SEND_PEP_ITEMS',
    readUserLogs: 'MON_R_USR_LOGS',
  },
  air: {
    updateCardsConfigView: 'AIR_U_CARDS_CFG_VIEW',
    readDashboard: 'AIR_R_DASHBOARD',
    readCards: 'AIR_R_CARDS',
    readModalities: 'AIR_R_MODALITIES',
    readMode: 'AIR_R_MODE',
    readIncidence: 'AIR_R_INCIDENCE',
  },
  infusion: {
    readDashboard: 'INFUSION_R_DASHBOARD',
    readCards: 'INFUSION_R_CARDS',
  },
  patient: {
    readPatientRecords: 'PATIENT_R_RECORD',
  },
  ecr: {
    readECRVariations: 'ECR_R',
  },
};

function parseActions(actionsPayload) {
  if (!actionsPayload) return null;
  if (typeof actionsPayload === 'object') return actionsPayload;
  try {
    return JSON.parse(actionsPayload);
  } catch {
    return null;
  }
}

function normalizeToArray(value) {
  if (!value) return [];
  if (Array.isArray(value)) return value;
  return [value];
}

function getHospitalActions(actions, currentHospital) {
  const hospitalKeys = Object.keys(actions);
  if (hospitalKeys.length === 0) return [];

  if (currentHospital && actions[currentHospital]) {
    return normalizeToArray(actions[currentHospital]);
  }

  if (currentHospital) {
    const matchedKey = hospitalKeys.find((key) => (
      key === currentHospital
      || key.startsWith(`${currentHospital}#`)
      || currentHospital.startsWith(`${key}#`)
    ));
    if (matchedKey) {
      return normalizeToArray(actions[matchedKey]);
    }
  }

  if (!currentHospital) {
    return hospitalKeys.flatMap((key) => normalizeToArray(actions[key]));
  }

  return normalizeToArray(actions[hospitalKeys[0]]);
}

function checkSingleAndMutiplePermissions(hospitalActions, action) {
  if (typeof action === 'string') {
    return hospitalActions.includes(action);
  }
  if (Array.isArray(action)) {
    return action.some((str) => hospitalActions.includes(str));
  }
  return false;
}

function hasPermission(action) {
  if (action === permissions.user.readUnlimitedSessionTimeout
    && process.env.REACT_APP_IS_DEMO) return false;
  if (process.env.REACT_APP_IS_DEMO) return true;

  const actions = parseActions(token.getIdToken()?.payload?.actions);
  if (!actions) return false;

  const currentHospital = window.sessionStorage.getItem('currentHospital');
  const hospitalActions = getHospitalActions(actions, currentHospital);

  if (hospitalActions.length === 0) return false;

  return checkSingleAndMutiplePermissions(hospitalActions, action);
}

export default hasPermission;
